import { useEffect, useState } from 'react';

import { useDialogCrup } from '../../../../../shared/hooks/DialogCrup';
import { getDecreeText } from '../../../../../shared/utils/invoice';

import { DeclareRegisterInvoiceService as Service } from '../../DeclareRegisterInvoiceService';

import { TokenElement } from './token-element';
import { ServiceProvider } from './service-provider';
import { ReceivingUnitInformation } from './receiving-unit-information';
import { AllowanceAccessInfo } from './allowance-access-info';
import { EInvoiceIntegrationRequest } from './eInvoice-integration-request';
import { EInvoiceSuspensionRequest } from './eInvoice-suspension-request';
import _ from 'lodash';
import moment from 'moment';
import { Button } from 'primereact/button';
import GuideEInvoiceSuspensionRequest from './guide-eInvoice-suspension-request';

export const CrupND70 = ({
  header,
  dataKey,
  tokens,
  setTokens,
  serviceProvider,
  setServiceProvider,
  receivingUnitInformation,
  setReceivingUnitInformation,
  allowanceAccessInfo,
  setAllowanceAccessInfo,
  eInvoiceIntegrationRequest,
  setEInvoiceIntegrationRequest,
  eInvoiceSuspensionRequest,
  setEInvoiceSuspensionRequest,
  reloadTokens,
  refreshLazyData,
  lastDeclaration
}) => {
  console.log("🚀 ~ CrupND70 ~ tokens:", tokens)

  const [providerOptions, setProviderOptions] = useState([]);
  const [receivingUnitOptions, setReceivingUnitOptions] = useState([]);
  const [visibleGuideEInvoiceSuspensionRequest, setVisibleGuideEInvoiceSuspensionRequest] = useState(false);
  const formatData = (data) => {
    if (data.formInvoice) {
      data.formInvoice = data.formInvoice.join(',');
    }
    if (data.formSendData) {
      data.formSendData = data.formSendData.join(',');
    }
    if (data.invoiceTypeUse) {
      data.invoiceTypeUse = data.invoiceTypeUse.join(',');
    }
    if (data.method) {
      data.method = data.method.join(',');
    }
    data.partners = data.partners || [];
    if (serviceProvider.length > 0) {
      data.partners.push(
        ..._.map(serviceProvider, (item) => {
          const formattedItem = {
            ..._.omit(item, ['id']),
            ...item,
            type: 0
          };
          if (formattedItem.fromDate) {
            formattedItem.fromDate = moment(formattedItem.fromDate).format('YYYY-MM-DD');
          }
          if (formattedItem.toDate) {
            formattedItem.toDate = moment(formattedItem.toDate).format('YYYY-MM-DD');
          }
          return formattedItem;
        })
      );
    }
    if (receivingUnitInformation.length > 0) {
      data.partners.push(
        ..._.map(receivingUnitInformation, (item) => {
          const formattedItem = {
            ..._.omit(item, ['id']),
            ...item,
            type: 1
          };
          if (formattedItem.fromDate) {
            formattedItem.fromDate = moment(formattedItem.fromDate).format('YYYY-MM-DD');
          }
          if (formattedItem.toDate) {
            formattedItem.toDate = moment(formattedItem.toDate).format('YYYY-MM-DD');
          }
          return formattedItem;
        })
      );
    }
    if (allowanceAccessInfo.length > 0) {
      data.dependentUnits = allowanceAccessInfo.map(item => ({
        ...item,
        fromDate: moment(item.fromDate).format('YYYY-MM-DD'),
        toDate: moment(item.toDate).format('YYYY-MM-DD')
      }))
    }
    console.log("🚀 ~ formatData ~ eInvoiceIntegrationRequest:", eInvoiceIntegrationRequest)
    if (eInvoiceIntegrationRequest.length > 0) {
      data.integrations = eInvoiceIntegrationRequest
    }
    if (eInvoiceSuspensionRequest.length > 0) {
      data.suspensions = eInvoiceSuspensionRequest.map(item => ({
        ...item,
        fromDate: moment(item.fromDate).format('YYYY-MM-DD'),
        toDate: moment(item.toDate).format('YYYY-MM-DD')
      }));
    }
    data.token = tokens;
    return data;
  }

  const { render, create, update, getValue, setValue, touched } = useDialogCrup({
    header,
    dataKey,
    width: '85rem',
    fields: [
      { field: 'cityCode', type: 'hidden' },
      { field: 'cityName', type: 'hidden' },
      { field: 'taxAuthorityCode', type: 'hidden' },
      { type: 'custom', className: 'md:col-12 text-center mb-0', body: <h2 className="mb-0">Tờ khai</h2> },
      { type: 'custom', className: 'md:col-12 text-center', body: <h5>Đăng ký/Thay đổi thông tin sử dụng hoá đơn điện tử</h5> },
      {
        field: 'formality', type: 'RadioButton', wrapName: 'justify-content-center', RadioButtonProps: {
          RadioButtons: [
            { className: 'md:col-2', value: 1, label: 'Đăng ký mới' },
            { className: 'md:col-2', value: 2, label: 'Thay đổi thông tin' }
          ]
        }
      },
      { field: 'dateCreate', header: 'Ngày lập', required: true, type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'region', header: 'Nơi lập', required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'taxpayers', header: 'Tên người nộp thuế', required: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'taxCode', header: 'Mã số thuế', className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'taxAuthorityName', header: 'Cơ quan thuế quản lý', required: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      {
        type: 'custom', className: 'md:col-12 text-center', body: (
          <div className="p-message p-component p-message-warn p-message-enter-done">
            <div className="p-message-wrapper">
              <span className="p-message-icon pi pi-info-circle"></span>
              <span className="p-message-detail">Thông tin người đại diện pháp luật phục vụ <b>Xác thực sinh trắc học</b> trên hệ thống phần mềm của CQT</span>
            </div>
          </div>
        )
      },
      { field: 'legalRepName', header: 'Tên người đại diện', required: true, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'legalRepPhone', header: 'Số điện thoại', required: true, InputTextProps: { maxLength: 16 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'legalRepIdentificationNumber', header: 'Căn cước công dân', InputTextProps: { maxLength: 12 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'legalRepPassport', header: 'Hộ chiếu', InputTextProps: { maxLength: 20 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'legalRepDob', header: 'Ngày tháng năm sinh', required: true, type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8', CalendarProps: { maxDate: new Date() } },
      { field: 'legalRepGender', header: 'Giới tính', type: 'Dropdown', required: true, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8', DropdownProps: { options: [{ value: 0, label: 'Nữ' }, { value: 1, label: 'Nam' }], filter: true }, },

      {
        type: 'custom', className: 'md:col-12 text-center', body: (
          <div className="p-message p-component p-message-warn p-message-enter-done">
            <div className="p-message-wrapper">
              <span className="p-message-icon pi pi-info-circle"></span>
              <span className="p-message-detail">Sau khi tờ khai được <b>chấp nhận</b>, cơ quan thuế sẽ <b>gửi các thông báo quan trọng</b> liên quan đến hoá đơn điện tử tới email/số điện thoại/địa chỉ này.</span>
            </div>
          </div>
        )
      },
      { field: 'personContact', header: 'Người liên hệ', required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'phone', header: 'Điện thoại liên hệ', required: true, InputTextProps: { maxLength: 20 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'address', header: 'Địa chỉ liên hệ', required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'email', type: 'email', header: 'Email liên hệ', required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-8', labelClassName: 'md:col-3', inputClassName: 'md:col-9' },
      {
        type: 'template',
        className: 'md:col-12',
        template: (item) => <p>{getDecreeText(item?.dateCreate)}</p>
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>1. Hình thức hóa đơn:</b>
      },
      {
        field: 'formInvoice', type: 'MultiCheckbox', className: 'pl-4', MultiCheckboxProps: {
          Checkboxes: [
            { value: 'CMa', label: 'Có mã của cơ quan thuế' },
            { value: 'CMTMTTien', label: 'Có mã của cơ quan thuế (Khởi tạo từ máy tính tiền)' },
            { value: 'KMa', label: 'Không có mã của cơ quan thuế' }
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>2. Hình thức gửi dữ liệu hóa đơn điện tử:</b>
      },
      {
        type: 'custom', className: 'md:col-12 text-center pl-4', body: (
          <div className="p-message p-component p-message-warn p-message-enter-done">
            <div className="p-message-wrapper">
              <span className="p-message-icon pi pi-info-circle"></span>
              <span className="p-message-detail">Vui lòng bỏ qua nếu bạn không thuộc đối tượng nào trong các đối tượng dưới đây.</span>
            </div>
          </div>
        )
      },
      {
        type: 'custom', className: 'md:col-12', body: <span className="pl-5">a. Trường hợp sử dụng hóa đơn điện tử có mã không phải trả tiền dịch vụ theo khoản 1 Điều 14 của Nghị định:</span>
      },
      {
        field: 'formSendData', type: 'MultiCheckbox', className: 'pl-8', MultiCheckboxProps: {
          Checkboxes: [
            {
              value: 'DBKK', label: 'Doanh nghiệp nhỏ và vừa, hợp tác xã, hộ, cá nhân kinh doanh tại địa bàn có điều kiện kinh tế xã hội khó khăn, địa bàn có điều kiện kinh tế xã hội đặc biệt khó khăn.', disabledDependency: (item) => {
                return item.formInvoice && item.formInvoice.includes('KMa');
              }
            },
            {
              value: 'UBND',
              label: 'Doanh nghiệp nhỏ và vừa khác theo đề nghị của Ủy ban nhân dân tỉnh, thành phố trực thuộc trung ương gửi Bộ Tài chính trừ doanh nghiệp hoạt động tại các khu kinh tế, khu công nghiệp, khu công nghệ cao.',
              disabledDependency: (item) => {
                return item.formInvoice && item.formInvoice.includes('KMa');
              }
            },
            {
              value: 'TSC',
              label: 'Cơ quan thuế hoặc cơ quan được giao nhiệm vụ tổ chức, xử lý tài sản công theo quy định pháp luật về quản lý, sử dụng tài sản công',
              disabledDependency: (item) => {
                return item.formInvoice && item.formInvoice.includes('KMa');
              }
            }
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <span className="pl-5">b. Trường hợp sử dụng hóa đơn điện tử không có mã của cơ quan thuế:</span>
      },
      {
        field: 'formSendData', type: 'MultiCheckbox', className: 'pl-8', MultiCheckboxProps: {
          Checkboxes: [

            {
              value: 'TVAN', label: 'Thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử (điểm b2, khoản 3, Điều 22 của Nghị định).', disabledDependency: (item) => {
                return item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('KMa'));
              }
            },
            {
              value: 'GTT', label: 'Chuyển dữ liệu hóa đơn điện tử trực tiếp đến cơ quan thuế (điểm b1, khoản 3, Điều 22 của Nghị định).', disabledDependency: (item) => {
                return item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('KMa'));
              }
            },
            // {
            //   value: 'NN', label: 'Nhà cung cấp ở nước ngoài không có cơ sở thường trú tại Việt Nam hoạt động thương mại điện tử, kinh doanh trên nền tảng số và các dịch vụ khác tại Việt Nam (điểm a.1 khoản 3 Nghị định)', disabledDependency: (item) => {
            //     return item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('KMa'));
            //   }
            // },
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>3. Phương thức chuyển dữ liệu hóa đơn điện tử:</b>
      },
      {
        field: 'method', type: 'MultiCheckbox', className: 'pl-4', MultiCheckboxProps: {
          Checkboxes: [
            {
              value: 'CDDu', label: 'Chuyển đầy đủ nội dung từng hóa đơn.', disabledDependency: (item) => {
                return item.formInvoice && (item.formInvoice.includes('CMa') || item.formInvoice.includes('CMTMTTien'));
              }
            },
            {
              value: 'CBTH', label: 'Chuyển theo bảng tổng hợp dữ liệu hóa đơn điện tử (điểm a1, khoản 3, Điều 22 của Nghị định).', disabledDependency: (item) => {
                return item.formInvoice && !item.formInvoice.includes('KMa');
              }
            }
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>4. Loại hóa đơn sử dụng</b>
      },
      {
        field: 'invoiceTypeUse', type: 'MultiCheckbox', className: 'pl-4', MultiCheckboxProps: {
          Checkboxes: [
            { value: 'GTGT', label: 'Hóa đơn GTGT' },
            { value: 'HDBH', label: 'Hóa đơn bán hàng' },
            { value: 'HDBTSCong', label: 'Hóa đơn bán tài sản công' },
            { value: 'HDBHDTQGia', label: 'Hóa đơn bán hàng dự trữ quốc gia' },
            { value: 'HDK', label: 'Các loại hóa đơn khác' },
            { value: 'CTu', label: 'Các chứng từ được in, phát hành, sử dụng và quản lý như hóa đơn' },
            { value: 'GTGTBL', label: 'Hóa đơn GTGT tích hợp biên lai thu thuế, phí, lệ phí' },
            { value: 'BHBL', label: 'Hóa đơn bán hàng tích hợp biên lai thu thuế, phí, lệ phí' },
            { value: 'HDTM', label: 'Hóa đơn thương mại' },
            // { value: 'HDNN', label: 'Hóa đơn nhà cung cấp ở nước ngoài không có cơ sở thường trú tại Việt Nam' },
          ]
        }
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>5. Danh sách chứng thư số sử dụng</b>
      },
      {
        type: 'custom', className: 'md:col-12', body: <TokenElement tokens={tokens} setTokens={setTokens} reloadTokens={reloadTokens} />
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>6. Tổ chức cung cấp dịch vụ</b>
      },
      {
        type: 'custom', className: 'md:col-12', body: <ServiceProvider items={serviceProvider} setItems={setServiceProvider} options={providerOptions} />
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>7. Thông tin đơn vị truyền nhận</b>
      },
      {
        type: 'custom', className: 'md:col-12', body: <ReceivingUnitInformation items={receivingUnitInformation} setItems={setReceivingUnitInformation} options={receivingUnitOptions} />
      },
      {
        type: 'custom', className: 'md:col-12', body: <b>8. Thông tin đơn vị hạch toán phục thuộc cần cấp quyền tra cứu</b>
      },
      {
        type: 'custom', className: 'md:col-12', body: <AllowanceAccessInfo items={allowanceAccessInfo} setItems={setAllowanceAccessInfo} />
      },
      {
        type: 'custom', className: 'md:col-12', body: <>
          <b>9. Đề nghị tạm ngừng  sử dụng hóa đơn điện tử <span className='text-blue-500 cursor-pointer' onClick={() => setVisibleGuideEInvoiceSuspensionRequest(true)}><span className="pi pi-question-circle"></span> Hướng dẫn</span></b>
        </>
      },
      {
        type: 'custom', className: 'md:col-12', body: <>
          <EInvoiceSuspensionRequest items={eInvoiceSuspensionRequest} setItems={setEInvoiceSuspensionRequest} options={providerOptions} tokens={tokens} />
          <GuideEInvoiceSuspensionRequest visible={visibleGuideEInvoiceSuspensionRequest} setVisible={setVisibleGuideEInvoiceSuspensionRequest} />
        </>
      },
    ],
    createItem: (item) => {
      return Service.create(formatData(item));
    },
    updateItem: (id, item) => {
      return Service.update(id, formatData(item));
    },
    refreshLazyData,
    layout: 'Horizontal',
    formClassName: 'paper'
  });

  const { formInvoice } = getValue();


  useEffect(() => {
    if (lastDeclaration?.partners) {
      setServiceProvider(
        lastDeclaration.partners
          .filter(item => item.type === 0)
          .map(item => ({
            ...item,
            fromDate: item.fromDate ? new Date(item.fromDate) : item.fromDate,
            toDate: item.toDate ? new Date(item.toDate) : item.toDate
          })) || []
      )
      setReceivingUnitInformation(
        lastDeclaration.partners
          .filter(item => item.type === 1).map(item => ({
            ...item,
            fromDate: item.fromDate ? new Date(item.fromDate) : item.fromDate,
            toDate: item.toDate ? new Date(item.toDate) : item.toDate
          })) || [])
      setAllowanceAccessInfo(
        lastDeclaration.dependentUnits
          .map(item => ({
            ...item,
            fromDate: item.fromDate ? new Date(item.fromDate) : item.fromDate,
            toDate: item.toDate ? new Date(item.toDate) : item.toDate,
          })) || [])
      setEInvoiceSuspensionRequest(
        lastDeclaration.suspensions
          .map(item => ({
            ...item,
            fromDate: item.fromDate ? new Date(item.fromDate) : item.fromDate,
            toDate: item.toDate ? new Date(item.toDate) : item.toDate,
          })) || [])
    }
  }, [lastDeclaration])

  useEffect(() => {
    if (formInvoice && touched) {
      if (formInvoice.length >= 1 && formInvoice.includes('KMa')) {
        const value = { ...getValue() };
        value.formSendData = ['TVAN'];
        value.method = ['CDDu'];
        if (value.dateCreate) {
          value.dateCreate = new Date(value.dateCreate);
        }
        setValue(value);
      } else if (formInvoice.includes('CMa') || formInvoice.includes('CMTMTTien')) {
        const value = { ...getValue() };
        value.formSendData = [];
        value.method = ['CDDu'];
        if (value.dateCreate) {
          value.dateCreate = new Date(value.dateCreate);
        }
        setValue(value);
      } else if (formInvoice.includes('KMa')) {
        const value = { ...getValue() };
        value.formSendData = ['TVAN'];
        value.method = [];
        if (value.dateCreate) {
          value.dateCreate = new Date(value.dateCreate);
        }
        setValue(value);
      }
    }
  }, [formInvoice]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    Service.getPartnerOptions().then((options) => {
      setProviderOptions(options.filter(item => item.type === 0));
      setReceivingUnitOptions(options.filter(item => item.type === 1));
    });
  }, []);

  return { render, create, update, setValue };
}